import 'leaflet';
const version = '0.0.1';

class MapInstance{
    static init(element){
        var $element = $(element);
        if($element.data('map-instance')){
            return $element.data('map-instance');
        }else{
            let instance = new MapInstance(element)
            $element.data('map-instance', instance);
            return instance
        }
    }

    constructor(element) {
        this.$element = $(element);
        this.element = element;
        console.log('MapInstance('+version+') init for: ', this.element);
        this.initMap();
    }

    initMap(){
        this.map = L.map('map', {
            scrollWheelZoom: false,
            zoomControl: false,
            fullscreenControl: true
        });
        this.renderer = L.canvas({ padding: 0.5 });
        L.control.zoom({
            position: 'topright'
        }).addTo(this.map);
        L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png").addTo(this.map);
        /*
        if(localStorage.getItem('center')){
            this.map.setView(localStorage.getItem('center').split(','), localStorage.getItem('zoom'));
        }else{
         */
        this.map.setView([55.3000, 23.9333], 8);
        //}

        this.map.on('moveend', function (e){
            this.storeMapCenter()
        }.bind(this))

        this.map.once('focus', function() {
            this.map.scrollWheelZoom.enable();
        }.bind(this));

        this.loadAllTerritories();
        this.loadAllObjects();

        $('.m_location').click(function(e){
            e.preventDefault();
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(function(position) {
                    var locationIcon = L.icon({
                        iconUrl: '/assets/images/map_icons/marker-icon.png',
                        iconSize: [25, 41],
                        iconAnchor: [12, 41],
                    });
                    this.map.setView([position.coords.latitude, position.coords.longitude], 8);
                    L.marker([position.coords.latitude, position.coords.longitude], {icon: locationIcon}).addTo(this.map);
                }.bind(this),
                function errorCallback(error) {
                    switch(error.code) {
                        case error.PERMISSION_DENIED:
                            alert("User denied the request for Geolocation.");
                            break;
                        case error.POSITION_UNAVAILABLE:
                            alert("Location information is unavailable.");
                            break;
                        case error.TIMEOUT:
                            alert("The request to get user location timed out.");
                            break;
                        case error.UNKNOWN_ERROR:
                            alert("An unknown error occurred.");
                            break;
                    }
                });
            } else {
                alert("Geolocation is not supported by this browser.");
            }
        }.bind(this));
    }

    loadAllTerritories(){

        $.getJSON('/api/gis/territories').done(function (result){
            var teritories = result.types;
            var $types = [];
            var allTeritoriesObject = true;
            var teritoryCodeArray = ['draustiniai', 'atkuriamieji_sklypai', 'biosferos_poligonai'];
            teritories.forEach(function (element, index){
                if (teritoryCodeArray.includes(element.code)){
                    $types[element.id] = L.geoJson(result.geodata, {
                        style: {
                            color: element.color
                        },
                        onEachFeature: function(feature, layer) {
                            layer.bindPopup(function(){
                                var popupContent = ''
                                $.ajax({
                                    url: '/gis/popupData',
                                    data: {id: feature.properties.id, type: 'Territories'},
                                    async: false
                                }).done(function(data) {
                                    popupContent =  data;
                                });
                                return popupContent;
                            });
                        },
                        renderer: this.renderer,
                        filter: function(feature, layer) {
                            return feature.properties.type == element.id;
                        }
                    });
                }
                else{
                    $types[element.id] = L.geoJson(result.geodata, {
                        style: {
                            color: element.color
                        },
                        onEachFeature: function(feature, layer) {
                            layer.bindPopup(function(){
                                var popupContent = ''
                                $.ajax({
                                    url: '/gis/popupData',
                                    data: {id: feature.properties.id, type: 'Territories'},
                                    async: false
                                }).done(function(data) {
                                    popupContent =  data;
                                });

                                return popupContent;
                            })
                            .bindTooltip(feature.properties.shortname, {permanent: true});
                        },
                        renderer: this.renderer,
                        filter: function(feature, layer) {
                            return feature.properties.type == element.id;
                        }
                    });
                }


                $types[element.id].addTo(this.map);

                $('#teritory-'+element.id).click(function(e) {
                    e.preventDefault();
                    if(allTeritoriesObject){
                        allTeritoriesObject = false;
                        $('.terr_filter').addClass('opacity');
                        $types.forEach(function (item, index) {
                            this.map.removeLayer(item);
                        }.bind(this));
                    }
                    $('#teritory-'+element.id).toggleClass('opacity');
                    $('.leaflet-tooltip').css('display', 'block');

                    if (this.map.hasLayer($types[element.id])) {
                        this.map.removeLayer($types[element.id]);
                    } else {
                        this.map.addLayer($types[element.id])
                    }
                }.bind(this));
            }.bind(this));
        }.bind(this))
    }
    loadAllObjects(){
        $.get('/api/gis/objects').done(function (result){
            var kinds = result.kinds;

            var $types = [];
            var $kindMarker = [];
            kinds.forEach(function (element){
                $kindMarker[element.id] = L.icon({
                    iconUrl: element.icon,
                    iconSize:     [20, 20], // size of the icon
                    iconAnchor:   [10, 10], // point of the icon which will correspond to marker's location
                });
                $types[element.id] = L.geoJson(result.geodata, {
                    renderer: this.renderer,
                    filter: function(feature, layer) {
                        return feature.properties.kind == element.id;
                    },
                    pointToLayer: function (feature, latlng) {
                        return L.marker(latlng, {icon: $kindMarker[element.id]}
                        ).on('click', function() {
                            var that = this;
                            $.get('/gis/popupData', {
                                id: feature.properties.id,
                                type: 'Objects'
                            }).done(function (result){
                                if (result) {
                                    that.bindPopup(result).openPopup();
                                }
                            });
                        });
                    }
                });

                $types[element.id].addTo(this.map);
                this.map.removeLayer($types[element.id]);

                $('#object-'+element.id).click(function(e) {
                    e.preventDefault();
                    $('#object-' + element.id).toggleClass('opacity');

                    if (this.map.hasLayer($types[element.id])) {
                        this.map.removeLayer($types[element.id]);
                    } else {
                        this.map.addLayer($types[element.id])
                    }
                }.bind(this));
            }.bind(this));
        }.bind(this))
    }

    /* Nebenaudojamas
    drawTeritory(element, color){
        L.polygon(element.latlngs, {color: color, renderer: this.renderer})
            .addTo(this.map)
            .bindPopup(element.id)
        ;
    }
     */

    //setPopupContent
    /* Nebenaudojamas
    drawObject(element){
        var coord = element.coordinates.split(',');
        if(coord[1])
        {
            L.circleMarker([coord[0], coord[1].trim()], {
                color:'#333333',
                renderer: this.renderer,
                radius: 1
            })
                .addTo(this.map)
                .bindPopup(element.title)
            ;
        }
    }
     */

    storeMapCenter(){
        localStorage.setItem('center', [this.map.getCenter().lat, this.map.getCenter().lng])
        localStorage.setItem('zoom', this.map.getZoom())
    }

    /*
    myLocation(){
        this.map.locate({setView: true, maxZoom: 15});
        this.map.on('locationfound', onLocationFound);
    }

    onLocationFound(e) {
        L.marker(e.latlng).addTo(this.map);
    }*/

    //    L.marker([mylat, mylong]).addTo(map)
    //         .bindPopup("<b>You are here!</b>").openPopup();

}

export default MapInstance;